// @flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

import type {
  BannerButtonEntityType,
  BannerContentPosition,
  BannerMediaType,
  BannerShapeType,
} from '../../../entities';

export const endpoints = Object.freeze({
  CREATE_BANNER_GROUP: `${env.baseApiUrl}/ui/admin/store/banner-group`,
  GET_BANNER_GROUP: `${env.baseApiUrl}/ui/admin/store/banner-group`,
  DELETE_BANNER_GROUP: `${env.baseApiUrl}/ui/admin/store/banner-group/:bannerId`,
  DELETE_BANNER: `${env.baseApiUrl}/ui/admin/store/banner/:bannerId`,
  EDIT_BANNER_GROUP: `${env.baseApiUrl}/ui/admin/store/banner-group/:bannerId`,
});

export const createBannerGroupApi = postCreator(endpoints.CREATE_BANNER_GROUP);
export const getBannerGroupApi = getCreator(endpoints.GET_BANNER_GROUP);
export const deleteBannerGroupApi = deleteCreator(
  endpoints.DELETE_BANNER_GROUP
);
export const editBannerGroupApi = putCreator(endpoints.EDIT_BANNER_GROUP);
export const deleteBannerApi = deleteCreator(endpoints.DELETE_BANNER);

export type CreateBannerRequest = {
  bannerMediaType: BannerMediaType,
  imageId?: string,
  imageResponsiveId?: string,
  videoUrl?: string,
  title?: string,
  subtitle?: string,
  backgroundColor: string,
  textColor: string,
  bannerTextPosition: BannerContentPosition,
  buttonText: string,
  bannerButtonEntityType: BannerButtonEntityType,
  buttonEntityIdentifier?: string,
  buttonBackgroundColor: string,
  buttonTextColor: string,
  enabled: boolean,
  padded: boolean,
  bannerShapeType: BannerShapeType,
  buttonReferenceEntityEnabled: boolean,
};
export type CreateBannerGroupRequest = {
  enabled: boolean,
  banners: CreateBannerRequest[],
};

export type UpdateBannerGroupRequest = {
  enabled: boolean,
  banners: CreateBannerRequest[],
};
